import DASHBOARD_ROUTES from './Dashboard/routes';
import SETTINGS_ROUTES from './Settings/routes';
import ALERTS_ROUTES from './Alert/routes';
import REPORT_ROUTES from './Report/routes';
import PLAYERS_ROUTES from './Players/routes';
import PLAYERS_GROUP_ROUTES from './PlayersGroup/routes';

const routes = [
    ...PLAYERS_ROUTES,
    ...PLAYERS_GROUP_ROUTES,
    ...DASHBOARD_ROUTES,
    ...SETTINGS_ROUTES,
    ...ALERTS_ROUTES,
    ...REPORT_ROUTES
];

export {
    routes
};
